import { useState } from 'react';

import GenericAccordian from '../../components/GenericAccordian/GenericAccordian';
import { getFormDefaultValue, getTableHeaders } from '../../utils/forms/FormDataModel';
import { ContentItem, OnAddArguments, TabContent } from '../../utils/forms/FormInterface';
import AbstractForm from '../Entity/AbstractForm';
import AbstractLanding from '../Entity/AbstractLanding';
import AbstractTabs, { TabActiosEventType, TabActiosProps } from '../Entity/AbstractTabs';
import { PHOTO_ORDER_APPLICATION } from '../../constants/EntityName';
import { PhotomitraOrderApplication } from '../../datamodels/PhotoOrderApplication';
import { Role } from '../../constants/AppConstant';
import { getRole } from '../../service/CookieManager';

const additionalEntityName = [{ name: PHOTO_ORDER_APPLICATION, getAllResponse: true }];

const PhotoOrderApplicationPage = () => {
  const [activeKey, setActiveKey] = useState<string>('0');
  const [userName, setUserName] = useState<string>();
  const [showFormComponent, setShowFormComponent] = useState<boolean>(false);
  const [refreshData, setRefreshData] = useState<boolean>(false);
  const [content, setContent] = useState<TabContent>([]);

  const defaultFormValue: any = getFormDefaultValue(PhotomitraOrderApplication);
  const tableHeaders: any = getTableHeaders(PhotomitraOrderApplication);
  const addName = 'Photo Order';
  const currentUserRole = getRole();
  const headerName = 'Photo Order';

  // Function to extract last 6 digits from order ID
  const getLast6DigitsFromOrderId = (orderId: string | undefined): string => {
    if (!orderId) return headerName;

    // Convert to string and extract all digits
    const orderIdStr = String(orderId);
    const digitsOnly = orderIdStr.replace(/\D/g, ''); // Remove all non-digit characters

    // Get last 6 digits
    if (digitsOnly.length >= 6) {
      return digitsOnly.slice(-6);
    }

    // If less than 6 digits, return all digits
    return digitsOnly || headerName;
  };

  const onSuccessful = (id?: string) => {
    if (id === 'create') {
      setShowFormComponent(false);
    }
    onTabClick('0');
    setRefreshData(prev => !prev);
  };

  const onAddNew = (argument1?: OnAddArguments) => {
    if (argument1) {
      const checkArr = content.filter((item: ContentItem) => item.key === argument1.id);
      checkArr.length ? null : onAdd(argument1);
    } else {
      setShowFormComponent(true);
      setUserName('Add Photo Order');
      onTabClick('a');
    }
  };

  const closeTab = (key: string, shouldRefresh: boolean) => {
    setContent(content => content.filter(item => item.key !== key));
    setActiveKey('0');
    shouldRefresh && setRefreshData(prev => !prev);
    key === 'a' && setShowFormComponent(false);
  };

  const onAdd = (argument1: OnAddArguments) => {
    const orderId = argument1.orderId || argument1.id;
    const tabTitle = orderId ? getLast6DigitsFromOrderId(orderId) : headerName;

    const newObj = {
      key: argument1.id,
      tabTitle: tabTitle,
      content: (
        <GenericAccordian key={content.length}>
          <AbstractForm
            entityId={argument1.id}
            isCreateMode={false}
            headerName={headerName}
            entityName={PHOTO_ORDER_APPLICATION}
            formTemplate={PhotomitraOrderApplication}
            formDefaultPayload={getFormDefaultValue(PhotomitraOrderApplication)}
            onSuccessfulUpdate={onSuccessful}
            formHeader=""
            showDeleteDraft={true}
            closeTab={closeTab}
            additionalEntityName={additionalEntityName}
            disabledButton={{ delete: currentUserRole !== Role.SUPER_ADMIN }}
          />
        </GenericAccordian>
      ),
    };

    // It is to make the newly added tab as active
    setContent((prev: any) => [...prev, newObj]);
    argument1.id && setActiveKey(String(argument1.id));
  };

  const onTabClick = (key: string) => {
    setActiveKey(key);
  };

  const updateFormVisibility = (
    action: TabActiosProps,
    targetKey?: string | TabActiosEventType
  ) => {
    if (action === 'remove') {
      if (targetKey === 'a') {
        setShowFormComponent(false);
        onTabClick('0');
      } else {
        onTabClick('0');
        // whenever a tab is closed, that tab is filtered out from the list of tabs which are rendered inside the AbstractTab component
        setContent(content => content.filter(item => String(item.key) !== targetKey));
      }
    }
  };

  return (
    <AbstractTabs
      activeKey={activeKey}
      entityName="Photo Order"
      updateFormVisibility={updateFormVisibility}
      onTabClick={onTabClick}
      secondTabTitle={userName}
      showFormComponent={showFormComponent}
      content={content}
      formComponent={
        <GenericAccordian>
          <AbstractForm
            isCreateMode={true}
            headerName={headerName}
            entityName={PHOTO_ORDER_APPLICATION}
            formTemplate={PhotomitraOrderApplication}
            formDefaultPayload={defaultFormValue}
            onSuccessfulUpdate={onSuccessful}
            closeTab={closeTab}
            additionalEntityName={additionalEntityName}
          />
        </GenericAccordian>
      }
    >
      <AbstractLanding
        headerName={headerName}
        addName={addName}
        entityName={PHOTO_ORDER_APPLICATION}
        tableHeaders={tableHeaders}
        onAdd={onAddNew}
        refreshData={refreshData}
        disableAdd
        showDownload={false}
        showFilter={true}
        filterListData
        reportRedirectPath="/documitra-reports"
      />
    </AbstractTabs>
  );
};

export default PhotoOrderApplicationPage;
